import React, { useState } from 'react'
import { useFormContext, useWatch } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { Button, Form } from 'semantic-ui-react'
import { FormFields } from '~/components/FormFields'
import QuestionPreview from './QuestionPreview'
import { StyledGroupQuestion } from '../style'

interface GroupedRadioProps {
  languageIndex: number
  type: string
  remove: (index: number) => void
  fields: any[]
  append: () => void
  removeSubQuestion: (index: number) => void
  appendSubQuestion: () => void
  subQuestions: any
}

const GroupedRadio: React.FC<GroupedRadioProps> = (props) => {
  const { languageIndex, remove, append, removeSubQuestion, appendSubQuestion, subQuestions } = props
  const { t } = useTranslation()
  const { control } = useFormContext()
  const watchQuestions = useWatch({ control, name: `languages[${languageIndex}].question` })
  const watchAnwser = useWatch({ control, name: 'answers' })
  const watchSubQ = useWatch({ control, name: 'groupQuestions' })
  const watchReq = useWatch({ control, name: 'required' })
  const [checked, setChecked] = useState([])

  function renderAnswers() {
    return <Form.Field>
      {props.fields?.map((answer, index) => {
        return <div key={answer?.key} style={{ display: 'flex', alignItems: 'center' }}>
          <FormFields.Input
            control={control}
            width={12}
            name={`answers[${index}].languages[${languageIndex}].answer`}
            label={t('Answer {{index}}', { index: index + 1 })}
            placeholder={t('Enter answer')}
            rules={{
              required: {
                value: true,
                message: t('Please enter answer')
              }
            }}
          />
          <Form.Button
            style={{ marginLeft: 10, marginTop: 7 }}
            onClick={() => remove(index)}
            size={'small'}
            basic
            color='red'
            type={'button'}
            icon='trash'
          />
        </div>
      })}
      <Button
        type='button'
        style={{ color: 'white' }}
        content={t('Add')}
        icon='plus'
        labelPosition='left'
        onClick={() => append()}
      />
    </Form.Field>
  }

  function renderSubQuestions() {
    return <Form.Field>
      {subQuestions?.map((question, index) => {
        return <div key={question.keyGroup} style={{ display: 'flex', alignItems: 'center' }}>
          <FormFields.Input
            control={control}
            key={question.keyGroup}
            width={12}
            name={`groupQuestions[${index}].languages[${languageIndex}].question`}
            label={t('Question {{index}}', { index: index + 1 })}
            placeholder={t('Enter question')}
            rules={{
              required: {
                value: true,
                message: t('Please enter question')
              }
            }}
          />
          <Form.Button
            style={{ marginLeft: 10, marginTop: 7 }}
            onClick={() => removeSubQuestion(index)}
            size={'small'}
            basic
            color='red'
            type={'button'}
            icon='trash'
          />
        </div>
      })}
      <Button
        type='button'
        style={{ color: 'white' }}
        content={t('Add')}
        icon='plus'
        labelPosition='left'
        onClick={() => appendSubQuestion()}
      />
    </Form.Field>
  }

  function renderPreview() {
    return <QuestionPreview>
      <Form.Field label={watchQuestions} required={Boolean(watchReq)} />
      {subQuestions?.map((question, questionIndex) => {
        return <div key={Math.random()} style={{ display: 'flex' }}>
          <StyledGroupQuestion
            label={question.languages[languageIndex].question}
          />
          <Form.Group widths={'equal'}>
            {props.fields?.map((anwser, index) => {
              return <Form.Field key={props.fields[index]?.key} style={{ textAlign: 'center' }}>
                <div className='radio-container'>
                  <label>{anwser.languages[languageIndex].answer}</label>
                  <Form.Checkbox
                    radio
                    checked={checked[questionIndex] === questionIndex + props.fields[index]?.key}
                    onChange={() => {
                      const temp = [...checked]
                      temp[questionIndex] = questionIndex + props.fields[index]?.key
                      setChecked(temp)
                    }}
                    style={{ marginTop: 3 }}
                  />
                </div>
              </Form.Field>
            })}
          </Form.Group>
        </div>
      })}
    </QuestionPreview>
  }

  return <>
    <FormFields.TextArea
      control={control}
      label={t('Type in your question')}
      placeholder={t('Type in your question')}
      name={`languages[${languageIndex}].question`}
      rules={{
        required: {
          value: true,
          message: t('Please enter question')
        }
      }}
    />
    {renderAnswers()}
    {renderSubQuestions()}
    {renderPreview()}
  </>
}
export default GroupedRadio